import AddItineraryContainer from './add-itinerary-container';

export default AddItineraryContainer;
